import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import PrivateRoute from "./components/common/PrivateRoute.js";
import Login from "./components/auth/login/Login.js";
import Main from "./components/layout/Main.js";
import SetPassword from "./components/auth/set_password/SetPassword.js";
import ResetPassword from "./components/auth/reset_password/ResetPassword.js";
import ProductReleasePage from "./components/product-release/ProductReleasePage.js";

import "react-responsive-modal/styles.css";
import "./App.css";
import "./components/styles/global.css";
import "react-responsive-modal/styles.css";
import { UserContext } from "./permissions/userContext.js";

class App extends Component {
	constructor(props) {
		super(props);
		this.state = {
			user: null
		};
	}

	componentDidMount() {
		const user = JSON.parse(localStorage.getItem("workflow_user"));
		if (user) {
			this.setState({ user });
		}
	}

	render() {
		const { user } = this.state;

		return (
			<Router>
				<div className="App">
					<Toaster position="top-center" reverseOrder={false} />

					<Switch>
						<Route exact path="/login" component={Login} />
						<Route exact path="/reset-password" component={ResetPassword} />
						<Route exact path="/set-password" component={SetPassword} />
						<Route exact path="/product-release/:version" component={ProductReleasePage} />
						<UserContext.Provider value={this.state.user}>
							<PrivateRoute component={() => <Main user={user} />} path="/" />
						</UserContext.Provider>
					</Switch>
				</div>
			</Router>
		);
	}
}

export default App;
